import { GroupingFactorWithGroups } from "../ars_ldm";
import { isGroup } from "./isGroup";
import { isNamedObject } from "./isNamedObject";
import { isObjectRecord } from "./isObjectRecord";

/**
 * Type guard to check if a value is a GroupingFactorWithGroups.
 *
 * Validates that the object has the required properties of a GroupingFactorWithGroups:
 * - NamedObject properties
 * - id: string
 * - dataDriven: false
 * - groups: Group[]
 *
 * @param obj - The value to check
 * @returns True if the object is a GroupingFactorWithGroups
 */
export const isGroupingFactorWithGroups = (obj: unknown): obj is GroupingFactorWithGroups => {
  if (!isObjectRecord(obj)) return false;
  // Check NamedObject properties
  if (!isNamedObject(obj)) return false;
  // Check required properties and their types
  if (typeof obj.id !== "string") return false;
  if (obj.dataDriven !== false) return false;
  if (!Array.isArray(obj.groups)) return false;
  if (obj.groups.some((group) => !isGroup(group))) return false;
  // Everything is good
  return true;
};
